import React from "react";

const Icon = ({ path }: { path: string }) => (
  <svg
    viewBox="0 0 24 24"
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={path} />
  </svg>
);

const stats = [
  {
    title: "Total Students",
    value: "12,450",
    change: "+18.2%",
    note: "from last month",
    icon: <Icon path="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />,
    color: "bg-blue-50 text-blue-700",
    ring: "ring-blue-100",
  },
  {
    title: "Active Courses",
    value: "42",
    change: "+6.4%",
    note: "new courses added",
    icon: <Icon path="M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 0 4 19.5v-15Z" />,
    color: "bg-violet-50 text-violet-700",
    ring: "ring-violet-100",
  },
  {
    title: "Mock Tests",
    value: "128",
    change: "+12.5%",
    note: "tests this week",
    icon: <Icon path="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />,
    color: "bg-orange-50 text-orange-700",
    ring: "ring-orange-100",
  },
  {
    title: "Revenue",
    value: "₹8.4L",
    change: "+24.1%",
    note: "monthly growth",
    icon: <Icon path="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6" />,
    color: "bg-emerald-50 text-emerald-700",
    ring: "ring-emerald-100",
  },
];

const courses = [
  {
    title: "NEET Complete Biology",
    batch: "NEET 2026",
    students: "4,250",
    progress: 82,
    color: "bg-blue-600",
  },
  {
    title: "JEE Physics Mastery",
    batch: "JEE Main",
    students: "3,180",
    progress: 74,
    color: "bg-violet-600",
  },
  {
    title: "Class 8 Science Foundation",
    batch: "Foundation",
    students: "2,460",
    progress: 68,
    color: "bg-cyan-600",
  },
];

const liveClasses = [
  {
    title: "NEET Biology: Human Physiology",
    teacher: "Dr. Neha Sharma",
    time: "10:00 AM",
    status: "Live Soon",
  },
  {
    title: "JEE Physics: Laws of Motion",
    teacher: "Prof. Raman Sir",
    time: "12:00 PM",
    status: "Scheduled",
  },
  {
    title: "Class 8 Science Revision",
    teacher: "Maical Doe",
    time: "04:30 PM",
    status: "Scheduled",
  },
];

const recentStudents = [
  { name: "Priya Sharma", course: "NEET Biology", amount: "₹4,999" },
  { name: "Aman Verma", course: "JEE Physics", amount: "₹5,499" },
  { name: "Riya Singh", course: "Class 8 Science", amount: "₹2,999" },
  { name: "Mohit Kumar", course: "Test Series", amount: "₹999" },
];

const chartBars = [42, 58, 45, 72, 64, 84, 76, 92, 70, 88, 96, 82];

const AdminDashboard: React.FC = () => {
  return (
    <div className="space-y-6 font-['Inter']">
      {/* Top Premium Hero */}
      <section className="relative overflow-hidden rounded-[30px] bg-slate-950 p-6 text-white shadow-xl shadow-slate-300/40 sm:p-8">
        <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-blue-500/30 blur-3xl" />
        <div className="absolute -bottom-24 left-1/2 h-72 w-72 rounded-full bg-cyan-400/20 blur-3xl" />

        <div className="relative grid gap-8 lg:grid-cols-[1.25fr_0.75fr] lg:items-center">
          <div>
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-xs font-black uppercase tracking-wide text-cyan-100">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              Mediit Academy Control Center
            </div>

            <h1 className="max-w-3xl text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl">
              Smart dashboard to manage your complete LMS.
            </h1>

            <p className="mt-4 max-w-2xl text-sm font-semibold leading-6 text-slate-300 sm:text-base">
              Students, batches, tests, live classes, payments and reports — sab kuch ek jagah se control karo.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <button className="rounded-2xl bg-white px-5 py-3 text-sm font-black text-slate-950 transition hover:bg-cyan-50">
                Create New Test
              </button>
              <button className="rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-sm font-black text-white transition hover:bg-white/15">
                Schedule Live Class
              </button>
            </div>
          </div>

          <div className="rounded-[28px] border border-white/10 bg-white/10 p-5 backdrop-blur-xl">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-bold text-slate-300">
                  Today&apos;s Performance
                </p>
                <h2 className="mt-1 text-3xl font-black">₹84,250</h2>
              </div>

              <div className="rounded-2xl bg-emerald-400/15 px-3 py-2 text-xs font-black text-emerald-300">
                +24.1%
              </div>
            </div>

            <div className="mt-7 flex h-28 items-end gap-2">
              {chartBars.map((bar, index) => (
                <div
                  key={index}
                  className="flex-1 rounded-t-xl bg-gradient-to-t from-cyan-400 to-blue-500"
                  style={{ height: `${bar}%` }}
                />
              ))}
            </div>

            <div className="mt-5 grid grid-cols-3 gap-3">
              <div className="rounded-2xl bg-white/10 p-3">
                <p className="text-xs font-bold text-slate-300">Orders</p>
                <p className="mt-1 text-xl font-black">186</p>
              </div>
              <div className="rounded-2xl bg-white/10 p-3">
                <p className="text-xs font-bold text-slate-300">Leads</p>
                <p className="mt-1 text-xl font-black">342</p>
              </div>
              <div className="rounded-2xl bg-white/10 p-3">
                <p className="text-xs font-bold text-slate-300">Classes</p>
                <p className="mt-1 text-xl font-black">08</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
        {stats.map((item) => (
          <div
            key={item.title}
            className="rounded-[26px] border border-slate-200 bg-white p-5 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="flex items-start justify-between gap-4">
              <div
                className={`flex h-12 w-12 items-center justify-center rounded-2xl ring-8 ${item.color} ${item.ring}`}
              >
                {item.icon}
              </div>

              <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-black text-emerald-600">
                {item.change}
              </span>
            </div>

            <p className="mt-6 text-sm font-bold text-slate-500">
              {item.title}
            </p>
            <h2 className="mt-1 text-3xl font-black tracking-tight text-slate-950">
              {item.value}
            </h2>
            <p className="mt-1 text-xs font-bold text-slate-400">
              {item.note}
            </p>
          </div>
        ))}
      </section>

      {/* Main Content */}
      <section className="grid gap-6 xl:grid-cols-[1fr_380px]">
        <div className="space-y-6">
          {/* Growth Chart */}
          <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
            <div className="mb-6 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
              <div>
                <h2 className="text-xl font-black text-slate-950">
                  Student Growth
                </h2>
                <p className="mt-1 text-sm font-semibold text-slate-500">
                  Monthly enrollment performance
                </p>
              </div>

              <div className="flex gap-2">
                <button className="rounded-xl bg-slate-950 px-4 py-2 text-xs font-black text-white">
                  Monthly
                </button>
                <button className="rounded-xl bg-slate-100 px-4 py-2 text-xs font-black text-slate-600">
                  Weekly
                </button>
              </div>
            </div>

            <div className="flex h-72 items-end gap-3 rounded-[24px] bg-slate-50 p-5">
              {chartBars.map((bar, index) => (
                <div key={index} className="flex flex-1 flex-col items-center gap-3">
                  <div className="flex h-56 w-full items-end">
                    <div
                      className="w-full rounded-t-2xl bg-gradient-to-t from-blue-600 to-cyan-400 shadow-lg shadow-blue-500/10"
                      style={{ height: `${bar}%` }}
                    />
                  </div>
                  <span className="text-[11px] font-black text-slate-400">
                    {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][index]}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Courses */}
          <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
            <div className="mb-5 flex items-center justify-between">
              <div>
                <h2 className="text-xl font-black text-slate-950">
                  Top Running Courses
                </h2>
                <p className="mt-1 text-sm font-semibold text-slate-500">
                  Courses with highest activity
                </p>
              </div>

              <button className="rounded-xl bg-blue-50 px-4 py-2 text-xs font-black text-blue-700 hover:bg-blue-100">
                View All
              </button>
            </div>

            <div className="space-y-4">
              {courses.map((course) => (
                <div
                  key={course.title}
                  className="rounded-[22px] border border-slate-100 bg-slate-50 p-4 transition hover:bg-white hover:shadow-md"
                >
                  <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
                    <div className="flex items-center gap-4">
                      <div className={`h-14 w-2 rounded-full ${course.color}`} />
                      <div>
                        <h3 className="font-black text-slate-950">
                          {course.title}
                        </h3>
                        <p className="mt-1 text-sm font-semibold text-slate-500">
                          {course.batch} • {course.students} students
                        </p>
                      </div>
                    </div>

                    <div className="min-w-[180px]">
                      <div className="mb-2 flex justify-between text-xs font-black text-slate-500">
                        <span>Progress</span>
                        <span>{course.progress}%</span>
                      </div>
                      <div className="h-2 rounded-full bg-slate-200">
                        <div
                          className={`h-2 rounded-full ${course.color}`}
                          style={{ width: `${course.progress}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <aside className="space-y-6">
          {/* Quick Actions */}
          <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <h2 className="text-xl font-black text-slate-950">
              Quick Actions
            </h2>

            <div className="mt-5 grid gap-3">
              {[
                "Add New Student",
                "Create Course",
                "Upload Questions",
                "Schedule Live Class",
              ].map((item) => (
                <button
                  key={item}
                  className="group flex items-center justify-between rounded-2xl border border-slate-100 bg-slate-50 px-4 py-3 text-left text-sm font-black text-slate-700 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
                >
                  {item}
                  <span className="transition group-hover:translate-x-1">→</span>
                </button>
              ))}
            </div>
          </div>

          {/* Live Classes */}
          <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-black text-slate-950">
                Today Live Classes
              </h2>
              <button className="text-xs font-black text-blue-700">
                View
              </button>
            </div>

            <div className="mt-5 space-y-4">
              {liveClasses.map((item) => (
                <div
                  key={item.title}
                  className="rounded-2xl border border-slate-100 bg-slate-50 p-4"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="text-sm font-black leading-5 text-slate-950">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-xs font-bold text-slate-500">
                        {item.teacher}
                      </p>
                    </div>

                    <span className="rounded-xl bg-white px-3 py-1 text-xs font-black text-slate-700">
                      {item.time}
                    </span>
                  </div>

                  <div className="mt-3 inline-flex rounded-full bg-emerald-50 px-3 py-1 text-xs font-black text-emerald-700">
                    {item.status}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Students */}
          <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm">
            <h2 className="text-xl font-black text-slate-950">
              Recent Enrollments
            </h2>

            <div className="mt-5 space-y-4">
              {recentStudents.map((student, index) => (
                <div key={student.name} className="flex items-center gap-3">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-slate-100 text-sm font-black text-slate-700">
                    {student.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </div>

                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-black text-slate-950">
                      {student.name}
                    </p>
                    <p className="truncate text-xs font-bold text-slate-500">
                      {student.course}
                    </p>
                  </div>

                  <p className="text-sm font-black text-slate-700">
                    {student.amount}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </section>
    </div>
  );
};

export default AdminDashboard;